<template>
    <div>
        <div v-for="n in maxPage" v-bind:class="['btn', (n == page) ? 'btn-dark' : 'btn-default']" v-bind:key="n" v-on:click.prevent="pageSearch(n)">{{n}}</div>
    </div>
</template>

<script>
    export default {
        name: 'Pager',
        props: {
            page: {
                default: () => {
                    return 1;
                }
            },
            maxPage: {
                default: () => {
                    return 1;
                }
            },
        },
        methods: {
            pageSearch: function (n) {
                this.$emit('paged', n);
            }
        }
    }
</script>

<style scoped>
</style>